import React from 'react'

import CloneForm from './CloneForm'
import ControlledModal from '../../../components/modals/ControlledModal'
import Header from './Header'
import ChecklistLoader from './_load/ChecklistLoader'

const CloneChecklistModal = props => {
  return (
    <ControlledModal width="38rem" {...props} disableClickOutside>
      <ChecklistLoader>
        <Header />
        <CloneForm />
      </ChecklistLoader>
    </ControlledModal>
  )
}

export default CloneChecklistModal
